import { useMemo } from 'react';

import { OrderStatusType } from 'api/types/entity/order/orderStatusType';
import { useTranslation } from 'libs/i18n';
import { Chip, ChipProps, ChipVariant } from 'libs/ui';

export interface ChipOrderStatusProps
  extends Pick<ChipProps, 'size' | 'uppercase'> {
  status: OrderStatusType;
}

export const ChipOrderStatus = ({
  status,
  uppercase,
  size,
}: ChipOrderStatusProps) => {
  const { t } = useTranslation();

  const color: ChipVariant = useMemo(() => {
    switch (status) {
      case OrderStatusType.New:
        return 'gray';
      case OrderStatusType.InProgress:
        return 'blue';
      case OrderStatusType.AwaitingComplianceCheck:
      case OrderStatusType.InComplianceCheck:
      case OrderStatusType.AwaitingAfmSubmission:
      case OrderStatusType.AwaitingExecutionCheck:
        return 'yellow';
      case OrderStatusType.ComplianceCheckPassed:
      case OrderStatusType.SentToAfm:
      case OrderStatusType.ExecutionCheck:
        return 'orange';
      case OrderStatusType.Revoked:
        return 'purple';
      case OrderStatusType.Cancelled:
        return 'violet';
      case OrderStatusType.Executed:
        return 'green';
      case OrderStatusType.NotExecuted:
        return 'pink';
      case OrderStatusType.PartiallyExecuted:
        return 'turquoise';
      default:
        return 'blue';
    }
  }, [status]);

  const text = useMemo(() => t(`order.status.${status}`), [status, t]);

  return <Chip size={size} text={text} uppercase={uppercase} variant={color} />;
};
